import { Config } from './config.interface';

export const developConfig: Config = {
  privyAppId: 'clvwrwuyh01tzt3q7h7wdixq1',
};
